// extracted by mini-css-extract-plugin
module.exports = {"dashed":"_4f720283bf--dashed--VgtT7","popup-text":"_4f720283bf--popup-text--qJ78A"};